import inView from './viewport';

export default function testimonialsCarousel () {
    const carouselLayouts = document.querySelectorAll('.testimonials_carousel');

    if (!carouselLayouts.length) {
        return;
    }

    carouselLayouts.forEach(layout => {
        const el = layout.querySelector('.swiper');

        if (el === null) {
            return;
        }

        const carousel_id = parseInt(el.getAttribute('data-id'), 10) || 99;

        const config = {
            loop: true,
            speed: 600,
            autoplay: false,
            spaceBetween: 30,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.button_next_' + carousel_id,
                prevEl: '.button_prev_' + carousel_id
            }
        };
        const carousel = new Swiper(el, config);
    });
}
